import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-calendario',
    templateUrl: './calendario.component.html'
})
export class CalendarioComponent implements OnInit {

    @Output() fecha = new EventEmitter();

    @Input() public date: Date;

    dates: Date[];
    rangeDates: Date[];
    minDate: Date;
    maxDate: Date;
    invalidDates: Array<Date>;
    es: any;

        constructor() { }

        ngOnInit() {
            this.es = {
                firstDayOfWeek: 1,
                dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
                dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
                dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
                monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
                                'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
                monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
                today: 'Hoy',
                clear: 'Borrar'
            };
            
            let today = new Date();
            let month = today.getMonth();
            let year = today.getFullYear();

            // let prevMonth = (month === 0) ? 11 : month -1;
            // let prevYear = (prevMonth === 11) ? year - 1 : year;
            // let Month = (month === 11) ? 0 : month + 1;
            // let nextYear = (nextMonth === 0) ? year + 1 : year;
            // this.minDate = new Date();
            // this.minDate.setMonth(prevMonth);
            // this.minDate.setFullYear(prevYear);
             this.maxDate = new Date();
             // this.maxDate.setMonth(month);
             // this.maxDate.setFullYear(year);
             this.maxDate.setDate(today.getDate());
            let invalidDate = new Date();
            invalidDate.setDate(today.getDate() - 1);
            this.invalidDates = [today, invalidDate];
        }
        lanzar(event){
            this.fecha.emit({nombre: this.date});
        }
     }



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/calendario.component.ts